export default "<api-date-difference [date1]=\"referenceTime\" [date2]=\"currentTime\" [hideMinutes]=\"hideMinutes\"></api-date-difference>"